
import { HttpGetBaseChargeList, HttpDeleteBaseChargeOne, HttpExportBaseCharge } from '@/service/account';
import TableList from "@components/templates/tablelist";
import compUpload from "@components/templates/selectupload";
import { mapGetters } from 'vuex';
import compIndex from "./update";
export default {
    mixins: [TableList],
    components: {
        compIndex,
        compUpload
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            workOrderSearchList: []
        };
    },
    methods: {
        ajaxRequest: HttpGetBaseChargeList,
        interceptRequest(data) {
            const weight = data.search.weight;
            data.weight = weight;
            delete data.search.weight;
            data.search.LE_startTime = data.search.effectTime;
            data.search.GE_endTime = data.search.effectTime;
            delete data.search.effectTime;
            return data
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case "export":
                    this.handleWebfs(
                        HttpExportBaseCharge,
                        this.interceptRequest(JSON.parse(JSON.stringify(this.formData))),
                        { executor: 'request', download: true }
                    );
                    break;
                case "delete":
                    this.operate = {
                        show: true,
                        alert: 'error',
                        params: { id: params },
                        title: this.$t('global.common.delete', { defaultValue: '删除' }),
                        ajaxRequest: HttpDeleteBaseChargeOne,
                        desc: this.$t('fbb.localemanage.confirm_delete', { defaultValue: '删除后不可恢复，是否确认删除？' }),
                        formdata: [
                            {
                                label: this.$t('global.common.notes', { defaultValue: '备注' }),
                                tag: "vTextarea",
                                key: 'remark',
                                span: 24,
                                labelWidth: 60,
                                required: false,
                            }
                        ]
                    }
                    break;
                case "import":
                    this.operate = {
                        show: true,
                        title: this.$t('fbb.inbound_import_data', { defaultValue: '导入数据' }),
                        width: 460,
                        showFooter: false,
                        name: "multipartFile",
                        component: "compUpload",
                        localurl:true,
                        actionurl:process.env.VUE_APP_APIURL_FBB+'/api/v2/carrierBaseCharge/import',
                        downrul:'/static/template/account_basecost.xlsx',
                        formdata: [
                            {
                                // label: this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}),
                                label: "承运商服务",
                                tag: "Select",
                                key:'carrierServiceCode',
                                options:this.getCarrierServiceAllList.map(item=>{
                                    return {
                                        label:item.label,
                                        value:item.attach.carrierServiceCode
                                    }
                                }),
                                props:{
                                    filterable:true,
                                },
                                labelWidth: 100,
                                span:24,
                                required:false,
                            },
                            {
                                label:this.$t('erp.channelbase.country',{defaultValue:'国家'}),
                                tag:'Select',
                                key:'regionCode',
                                options:this.getCountryList.map(item=>{
                                    return {
                                        value:item.value,
                                        label:item.label
                                    }
                                }),
                                labelWidth: 100,
                                span:24,
                                required:false,
                            },
                            {
                                label:this.$t('fbb.account.takeeffect',{defaultValue:'生效开始日期'}),
                                key:'startTime',
                                tag: "vDatepicker",
                                props: {
                                    format: "yyyy-mm-dd",
                                    confirm: false,
                                },
                                labelWidth: 100,
                                span:24,
                            },
                            {
                                label:this.$t('fbb.account.takeeffectend',{defaultValue:'生效结束日期'}),
                                key:'endTime',
                                tag: "vDatepicker",
                                props: {
                                    format: "yyyy-mm-dd",
                                    confirm: false,
                                },
                                labelWidth: 100,
                                span:24,
                            },
                        ],

                    };
                    break;
                case "query":
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "compIndex",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "edit":
                    this.$router.push({
                        name: 'carrierbasecostUpdate',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;

            }
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [
                {
                    label: this.$t('global.common.query'),
                    to: {
                        name: "carrierbasecostUpdate",
                        params: {
                            type: 'query',
                        },
                        query: { id }
                    },
                    show: true
                },
                {
                    label: this.$t('global.common.edit'),
                    params: id,
                    to: {
                        name: "carrierbasecostUpdate",
                        params: {
                            type: 'edit',
                        },
                        query: { id }
                    },
                    show: true
                },
                {
                    label: this.$t('global.common.delete'),
                    params: id,
                    operate: 'delete',
                    show: true
                },
            ];
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getBillcusWareList', 'getCusproductList','getCarrierServiceList','getCountryList', 'getCarrierServiceAllList']),
        ToolsData() {
            return [
                {
                    label: this.$t('fbb.alloment.muti_import', { defaultValue: '批量导入' }),
                    theme: "primary",
                    operate: 'import',
                },
                {
                    label: this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: "export",
                    theme:"info",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    // label: this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}),
                    label: "承运商服务",
                    key: 'EQ_systemCarrierServiceId',
                    tag: 'Select',
                    options:this.getCarrierServiceAllList,
                    props:{
                        filterable:true,
                    },
                    show: true,
                },
                {
                    label: this.$t('fbb.settlement.zoneCode',{defaultValue:'分区代码'}),
                    key: 'EQ_zoneCode',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: this.$t('global.common.weight',{defaultValue:'重量'}),
                    key: 'weight',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label:this.$t('erp.channelbase.country',{defaultValue:'国家'}),
                    tag:'Select',
                    key:'EQ_regionCode',
                    options:this.getCountryList.map(item=>{
                        return {
                            value:item.value,
                            label:item.label
                        }
                    }),
                },
                {
                    label:this.$t('fbb.account.takeeffect',{defaultValue:'生效日期'}),
                    key:'effectTime',
                    tag: "vDatepicker",
                    props: {
                        format: "yyyy-mm-dd",
                        confirm: false,
                    },
                },
            ]
        },
        columns() {
            return [
                {
                    title: this.$t('global.common.actions', { defaultValue: '操作' }),
                    width: 80,
                    render: this.getOperateNodes
                },
                {
                    // title: this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}),
                    title: "承运商服务",
                    key: 'workOrderNo',
                    render: (h, { row }) => {
                        return <div>
                            <div>
                                {/* <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{this.findRenderLabel(this.getCarrierServiceList, row.carrierServiceId)}</a> */}
                                <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{`${row.carrierServiceName}(${row.carrierServiceCode})`}</a>
                                <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            </div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.settlement.zoneCode',{defaultValue:'分区代码'}),
                    key: 'zoneCode',
                    width: 80,
                },
                {
                    title:this.$t('erp.channelbase.country',{defaultValue:'国家'}),
                    key:'regionCode',
                    render:(h,{row})=>{
                        const countryList=this.getCountryList.filter(item=>{
                            return item.value==row.regionCode
                            }
                        )
                        return countryList[0]?countryList[0].label:'--'
                    }
                },
                {
                    title: this.$t('global.common.weight',{defaultValue:'重量'})+'(lbs)',
                    key: 'weight',
                    width: 80,
                },
                {
                    title: this.$t('fbb.analyze.cost',{defaultValue:'费用'})+'(usd)',
                    key: 'cost',
                },
                {
                    title:this.$t('fbb.account.takeeffectstart',{defaultValue:'生效开始日期'}),
                    key:'startTime',
                },
                {
                    title:this.$t('fbb.account.takeeffectend',{defaultValue:'生效结束日期'}),
                    key:'endTime',
                },
                {
                    title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
                    key: 'updatedAt',
                }];
        },
    },
};




